import { render, staticRenderFns } from "./USDT-BINANCE.vue?vue&type=template&id=3f78448a&scoped=true"
import script from "./USDT-BINANCE.vue?vue&type=script&lang=js"
export * from "./USDT-BINANCE.vue?vue&type=script&lang=js"
import style0 from "./USDT-BINANCE.vue?vue&type=style&index=0&id=3f78448a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78448a",
  null
  
)

export default component.exports